export const PRICE_WHOLE_PART = "price-whole-part";
export const PRICE_DECIMAL_PART = "price-decimal-part";
